// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { pageTitleStyles } from "@guestsupply/Overrides/Widgets/ProductDetails/ProductDetailsPageTitle";
import FreightCharges from "@guestsupply/XDL/Icons/FreightCharges";
import { createLinkIconStyles, hideElementOnPrint } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

pageTitleStyles.brandGridItem = {
    css: css`
        display: none;
        ${hideElementOnPrint}
    `,
};

pageTitleStyles.titleGridItem = {
    width: 12,
};
pageTitleStyles.titleText = {
    variant: "h1",
    lineHeight: "26px",
    css: css`
        margin-bottom: 8px;
        @media print {
            margin-bottom: 0;
            line-height: 26px;
        }
    `,
};
pageTitleStyles.surchargesGridItem = {
    width: 12,
    css: css`
        align-items: baseline;
    `,
};
pageTitleStyles.surchargesTooltip = {
    cssOverrides: {
        tooltipClickable: css`
            margin-left: 0;
        `,
    },
};
pageTitleStyles.totalFreightChargesLink = {
    ...createLinkIconStyles(FreightCharges, {
        typographyProps: {
            size: 12,
            weight: "bold",
            css: css`
                margin-left: 8px;
                line-height: 12px;
            `,
        },
        icon: {
            iconProps: {
                size: 18,
                color: "text.link",
            },
            position: "left",
        },
        css: css`
            &&& {
                display: flex;
            }
        `,
    }),
};
pageTitleStyles.surchargesText = {
    size: 14,
    weight: "bold",
};
